import { Flex, Span, Spinner } from "@goodfill/ui-components";
import { API } from "aws-amplify";
import { useState, useCallback, useEffect } from "react";
import { toast } from "react-hot-toast";
import { doGetOrderTicket, doGetTradeTicket } from "@goodfill/models-typescript";
import { TradeDetail } from "./TradeDetail";
import { useRecoilValue } from "recoil";
import { pricedBondState } from "../../../../state";
import { useParams } from "react-router-dom";
import { logoUrlByTicker } from "../../../../assets/tickerAssetsIndex";
import { TradeTicketDetailEntity, OrderTicketDetailEntity } from "@goodfill/domain-entities";
import { asTradeTicketId } from "@goodfill/domain-properties";

export const TradeDetailSection = () => {
  const { tradeTicketId: tradeTicketIdParam } = useParams();

  const pricedBonds = useRecoilValue(pricedBondState);
  const [isLoading, setIsLoading] = useState(false);
  const [tradeTicket, setTradeTicket] = useState<TradeTicketDetailEntity | null>(null);
  const [orderTicket, setOrderTicket] = useState<OrderTicketDetailEntity | null>(null);

  const init = useCallback(async () => {
    try {
      setIsLoading(true);
      const _tradeTicket = await doGetTradeTicket(API, asTradeTicketId(tradeTicketIdParam ?? ""));
      setTradeTicket(_tradeTicket);
      const _orderTicket = await doGetOrderTicket(API, _tradeTicket.orderTicketId);
      setOrderTicket(_orderTicket);
    } catch (e) {
      console.error(e);
      toast.error(`Loading Trade Ticket failed ${e}`);
    } finally {
      setIsLoading(false);
    }
  }, [tradeTicketIdParam]);

  useEffect(() => {
    init();
  }, [init]);

  const bond = orderTicket ? pricedBonds.get(orderTicket.bondId) ?? null : null;
  const logoImageUrl = bond ? logoUrlByTicker(bond.issuerTicker) : null;

  return (
    <Flex direction="col" verticalMargin={2} horizontalMargin={8} horizontalPadding={8} gap={8} width="w-full">
      <Flex direction="row" items="center" justify="between" verticalMargin={4}>
        <Span font="semibold" size="lg">
          Trade Ticket
        </Span>
        {logoImageUrl ? <img alt="" style={{ height: "71px" }} src={logoImageUrl} /> : null}
      </Flex>

      {isLoading ? (
        <Spinner />
      ) : tradeTicket === null ? (
        "Error: Trade Ticket not loaded"
      ) : orderTicket === null ? (
        "Error: Order Ticket not loaded"
      ) : bond === null ? (
        "Error: Bond not found"
      ) : (
        <TradeDetail tradeTicket={tradeTicket} orderTicket={orderTicket} bond={bond} />
      )}
    </Flex>
  );
};
